import styled from 'styled-components/macro'

export const EvidenceShowTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  width: 100%;
`

export const EvidenceBodiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  flex: 1 0 auto;
  max-height: 100%;
`
